import { z } from "zod";

const MAX_RECIENTES = 6;
const slugSchema = z.string().regex(/^[a-z0-9]+(-[a-z0-9]+)*$/);

const clave = (userId: string) => `ads:${userId}:recientes`;

/**
 * Clientes usados por este usuario, el más reciente primero. Solo decide adónde va `/`:
 * el cliente activo de una pestaña lo manda siempre la URL. Cualquier fallo de almacenamiento
 * (modo privado, cuota, valor manipulado) se lee como «sin recientes».
 */
export function leerRecientes(userId: string): string[] {
  try {
    const raw = localStorage.getItem(clave(userId));
    if (!raw) return [];
    const parsed: unknown = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [];
    return parsed.filter((item): item is string => slugSchema.safeParse(item).success).slice(0, MAX_RECIENTES);
  } catch {
    return [];
  }
}

export function registrarReciente(userId: string, slug: string): void {
  if (!slugSchema.safeParse(slug).success) return;
  const siguiente = [slug, ...leerRecientes(userId).filter((s) => s !== slug)].slice(0, MAX_RECIENTES);
  try {
    localStorage.setItem(clave(userId), JSON.stringify(siguiente));
  } catch {
    // El almacenamiento es opcional: sin él, `/` va al primer cliente.
  }
}
